import React, { Component } from "react";
import { Row, Col, Container, Form, Button, Table, Image, Card } from "react-bootstrap";
// import SelectDropDown from '../selectdropdown/SelectDropDown';
import SelectDropDown from "../../selectdropdown/SelectDropDown";
import { components } from 'react-select'
import moment, { invalid } from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import MaterialCreationModal from './MaterialCreationModal';
import { MaterialTableShimmer } from './MaterialAssignShimmer';
import MaterialTabs from '../MaterialTabs';
import "./_materialAllocation.scss";
import Select from "react-select";


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};


const CREATE_MEATRIALS_ALLCATION = gql`
mutation($params:CreateMaterialAllocation){
    createMaterialAllocation(params:$params)
}
`;

class MeatrialAssigning_to_Students extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStudentDetails: [],
            overAllstudentsDetails: props.getStudents,
            studentDetailsError: "",
            selectedMaterialType: "",
            overAllMaterialTypes: [],
            materialsTypesError: "",
            dataError: "",
            loading: 0,
            getAllocatedMaterials: [],
            is_exist: false,
            materialCreationModal: false,
            materialNameError: "",
            studentnameSearch: "0",
            studentnameSearchval: "",
            loadingSpinner: "",
            submitError: "",
            is_grouping: true
        };
    };


    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        //student name
        if (name == "studentnameSearch") {

            let studentnameSearchData = []

            if (value != "0") {
                this.getMaterialTypes();
                studentnameSearchData = this.state.overAllstudentsDetails.filter((item) => item.student_id == value);
                console.log("studentnameSearchData", studentnameSearchData);
                this.setState({
                    studentnameSearchval: {
                        value: studentnameSearchData[0].student_id,
                        label: `${studentnameSearchData[0].student_name}(${studentnameSearchData[0].roll_no})`
                    },
                    selectedStudentDetails: studentnameSearchData,
                    studentDetailsError: "",
                    selectedMaterialType: "",
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    overAllMaterialTypes: [],
                    submitError: "",
                });
            } else {
                this.setState({
                    studentnameSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    selectedStudentDetails: [],
                    studentDetailsError: "",
                    selectedMaterialType: "",
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    overAllMaterialTypes: [],
                    submitError: "",
                });
            }
        }

        this.setState({ [name]: value });

    };

    dropDownGetValues(fieldname) {
        let getArray = [];
        const newObj1 = {
            value: "0",
            label: "Select"
        }
        getArray.push(newObj1);
        if (fieldname == "studentnameSearch") {
            this.state.overAllstudentsDetails.map((stumap) => {
                const newObj = {
                    value: stumap.student_id,
                    label: `${stumap.student_name}(${stumap.roll_no})`
                }
                getArray.push(newObj);
            });
        }
        console.log("getArray", getArray);
        return getArray;
    };

    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log("name", name, value);

        if (name == "materialsTypes") {
            if (value != 0) {
                let grouping = this.state.overAllMaterialTypes.find((item) => item.id == value).is_grouping == 1 ? true : false

                this.setState({
                    selectedMaterialType: value,
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    submitError: "",
                    is_grouping: grouping
                })
            } else {
                this.setState({
                    selectedMaterialType: "",
                    materialsTypesError: "",
                    getAllocatedMaterials: [],
                    materialNameError: "",
                    dataError: "",
                    submitError: "",
                    is_grouping: true
                })
            }

        }
    };

    getMaterialTypes = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($id:Int){
                getMaterialTypes(id:$id){
                    id
                    material_type
                    is_grouping
                  }
               }
            `,
            variables: {
                id: 0,
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterialTypes.length > 0) {
            let data = result.data.getMaterialTypes;
            console.log("data", data)
            this.setState({ overAllMaterialTypes: data })
        } else {
            this.setState({ overAllMaterialTypes: [] })
        }

    };

    getDisplayData = async (e) => {

        if (!this.state.selectedStudentDetails.length) {
            this.setState({ studentDetailsError: "Please Select Students", });
            return ""
        }

        if (this.state.selectedMaterialType === "" || this.state.selectedMaterialType === "--Select Materail--") {
            this.setState({ materialsTypesError: "Please Select Material Type ", variables: [] });
            return ""
        }


        // getMaterials

        this.setState({ loading: 1 });
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$class_id:Int,$material_type_id:Int){
                getMaterials(institute_id:$institute_id,branch_id:$branch_id,class_id:$class_id,material_type_id:$material_type_id){
                    id
                    material_name
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(Cookies.get("branch_id")),
                class_id: parseInt(this.state.is_grouping ? this.state.selectedStudentDetails[0].class_id : ""),
                material_type_id: parseInt(this.state.selectedMaterialType)
            },
            fetchPolicy: 'network-only'
        })

        console.log("getMaterials", result);

        // getMaterialAllocationDetails



        const result1 = await this.props.client.query({
            query: gql`
            query($edu_student_id:Int,$material_type_id:Int){
                getMaterialAllocationDetails(edu_student_id:$edu_student_id, material_type_id:$material_type_id){
                    materials
                  }
               }
            `,
            variables: {
                edu_student_id: parseInt(this.state.selectedStudentDetails[0].student_id),
                material_type_id: parseInt(this.state.selectedMaterialType)
            },
            fetchPolicy: 'network-only'
        })



        let overAllDetails = await Promise.all([{ getMaterials: result.data.getMaterials }, { getMaterialAllocationDetails: result1.data.getMaterialAllocationDetails }]);

        console.log("overAllDetails", overAllDetails);

        let getCombineMaterials = [];
        console.log("details", overAllDetails[1]);
        let materaialData = (overAllDetails[1]?.getMaterialAllocationDetails).length > 0 ? JSON.parse(overAllDetails[1]?.getMaterialAllocationDetails[0]?.materials) : []
        if (overAllDetails[0].getMaterials.length > 0) {

            if (materaialData.length > 0) {

                overAllDetails[0].getMaterials.map((item) => {
                    // let allocatedData =  overAllDetails[1]?.getMaterialAllocationDetails[0].materials.find((item1) => item1.material_id == item.id);
                    //  console.log("testing",JSON.parse(overAllDetails[1]?.getMaterialAllocationDetails[0]?.materials));
                    const allocatedData = materaialData.find((item1) => item1.material_id == item.id)

                    console.log("allocatedData", allocatedData);
                    if (allocatedData != null) {
                        let checked = false;
                        let disabled = false;

                        if (allocatedData.materialDeliveredTime != "") {
                            checked = true
                        }
                        if (allocatedData.materialDeliveredTime != "" && allocatedData.materialRecvAcceptTime != "") {
                            disabled = true
                        }
                        getCombineMaterials.push({ material_id: allocatedData.material_id, materialDeliveredTime: allocatedData.materialDeliveredTime, material_name: item.material_name, materialRecvAcceptTime: allocatedData.materialRecvAcceptTime, checked: checked, isDisabled: disabled })
                    } else {
                        getCombineMaterials.push({ material_id: item.id, materialDeliveredTime: "", material_name: item.material_name, materialRecvAcceptTime: "", checked: false, isDisabled: false })
                    }
                })

            } else {
                overAllDetails[0].getMaterials.map((item) => {
                    getCombineMaterials.push({ material_id: item.id, materialDeliveredTime: "", material_name: item.material_name, materialRecvAcceptTime: "", checked: false, isDisabled: false, materialNameError: "" })
                })
            }
        }

        this.setState({ getAllocatedMaterials: getCombineMaterials, loading: 0, is_exist: materaialData.length > 0 ? true : false, materialNameError: "", loader: 0, dataError: "No Data Found" });

    };

    handleSelectChekBoxChange = (e) => {
        const { name, value, checked } = e.target;
        console.log("nnnn", name, value, checked);

        let data = [];
        this.state.getAllocatedMaterials.map((item) => {
            if (item.material_id == value) {
                let time = ""
                if (checked) {
                    time = moment(new Date()).unix().toString()
                }
                data.push({ ...item, checked: checked, materialDeliveredTime: time })
            } else {
                data.push({ ...item })
            }
        });
        this.setState({ getAllocatedMaterials: data, materialNameError: "", submitError: "" })
    };

    onSubmittedDetails = () => {
        const errorValidation = this.state.getAllocatedMaterials.every((obj) => (
            obj.checked == false
        ));
        console.log("errorValidation", errorValidation);
        if (this.state.getAllocatedMaterials.length > 1 && errorValidation) {
            this.setState({
                submitError: 'Please Select at atleast one',
            });
            return ""
        }

        let data = [];

        this.state.getAllocatedMaterials.map((item) => {
            data.push({ material_id: item.material_id, material_name: item.material_name, materialDeliveredTime: item.materialDeliveredTime, materialRecvAcceptTime: item.materialRecvAcceptTime })
        })

        const params = {
            edu_student_id: parseInt(this.state.selectedStudentDetails[0].student_id),
            material_type_id: parseInt(this.state.selectedMaterialType),
            is_exist: this.state.is_exist,
            materials: JSON.stringify(data)
        }
        this.setState({ loadingSpinner: 1 })
        console.log("params", params);


        this.createMaterialAllocation(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
            setTimeout(() => {
                window.location.reload(false);
            }, 1500);
        });
    };

    createMaterialAllocation = async params => {
        await this.props.createMaterialAllocation({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("data777", data);
                if (data.createMaterialAllocation) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        window.location.reload(false);
                    }, 1500);
                }

            }
        })
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
    };

    nextPage = () => {
        this.props.history.push({
            pathname: "/material-report",
            back: "/material-assigning"
        });
    }


    nextPageFunc = () => {
        this.props.history.push({
            pathname: "/material-store",
            back: "/material-assigning"
        });
    }

    render() {

        let StudentsFilterData = [];
        if (this.state.studentnameSearch != "0") {
            StudentsFilterData = this.state.overAllstudentsDetails
            if (this.state.studentnameSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.student_id == this.state.studentnameSearch);
            }
        } else {
            StudentsFilterData = this.state.overAllstudentsDetails
        }
        console.log("state121212", this.state);
        console.log("props", this.state);

        const FIN = {
            wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
            cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
            iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
            cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
            cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
            cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
            headerActions: { display: "flex", gap: 10, marginLeft: "auto", flexWrap: "wrap" },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
            btnOutline: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#f5f3ff", color: "#7c3aed", border: "1px solid #ddd6fe", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
            filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
            label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
            select: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 42 },
            err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
            content: { padding: "20px 24px" },
        };

        return (
            <div style={FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={FIN.card}>
                        <MaterialTabs active="assigning" />
                        {/* Header */}
                        <div style={FIN.cardHeader}>
                            <div style={FIN.iconWrapper}><i className="fal fa-clipboard-list" /></div>
                            <div style={FIN.cardTitleText}>
                                <h5 style={FIN.cardTitle}>Materials Assignment</h5>
                                <span style={FIN.cardSubtitle}>Allocate &amp; track materials issued to students</span>
                            </div>
                            <div style={FIN.headerActions}>
                                <button style={FIN.btnPrimary} onClick={() => { this.setState({ materialCreationModal: true }) }}>
                                    <i className="fas fa-plus" /> Material Creation
                                </button>
                            </div>
                        </div>

                        {/* Filters */}
                        <div style={FIN.filterBar}>
                            <Row className="g-2 align-items-end">
                                <Col xl={3} lg={4} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Select Student</label>
                                    <SelectDropDown
                                        stateData={this.state.studentnameSearchval}
                                        handleChange={this.selecthandleInputChange}
                                        name="studentnameSearch"
                                        options={this.dropDownGetValues("studentnameSearch")}
                                        placeholderName={'Student Name'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                    />
                                    {this.state.studentDetailsError ? <span style={FIN.err}>{this.state.studentDetailsError}</span> : null}
                                </Col>
                                <Col xl={3} lg={4} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Material Type</label>
                                    <select style={FIN.select} name="materialsTypes" onChange={this.handleInputChange} value={this.state.selectedMaterialType}>
                                        <option value="0">--Select Material--</option>
                                        {this.state.overAllMaterialTypes.map((materials) => (
                                            <option key={materials.id} value={materials.id}>{materials.material_type}</option>
                                        ))}
                                    </select>
                                    {this.state.materialsTypesError ? <span style={FIN.err}>{this.state.materialsTypesError}</span> : null}
                                </Col>
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <button style={{ ...FIN.btnPrimary, width: "100%" }} onClick={this.getDisplayData}>
                                        <i className="fas fa-search" /> Get Details
                                    </button>
                                </Col>
                            </Row>
                        </div>

                        {/* Content */}
                        <div style={FIN.content}>
                            {this.state.loading == 1 ? (
                                <MaterialTableShimmer rows={6} cols={2} />
                            ) : this.state.getAllocatedMaterials.length > 0 ? (
                                <div style={{ background: "#fff", border: "1px solid #eef2f7", borderRadius: 14, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", padding: "18px 20px" }}>
                                    {this.state.selectedStudentDetails.map(student => (
                                        <div key={student.student_id} style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
                                            <span style={{ fontWeight: 700, color: "#0f172a", fontSize: 15 }}>
                                                <i className="fas fa-user-graduate" style={{ color: "#7c3aed", marginRight: 7 }} />{student.student_name}
                                            </span>
                                            <span style={{ background: "#f1f5f9", color: "#475569", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>{student.class_name}</span>
                                            <span style={{ background: "#ede9fe", color: "#6d28d9", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>{student.section_name}</span>
                                        </div>
                                    ))}
                                    <div className="table-responsive">
                                        <Table className="table table-bordered table-hover mb-0">
                                            <thead style={{ background: "#f8fafc", color: "#475569" }}>
                                                <tr style={{ textAlign: "center" }}>
                                                    <th style={{ width: 70 }}>S.No</th>
                                                    <th style={{ textAlign: "left" }}>Material Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.getAllocatedMaterials.map((item, index) => (
                                                    <tr key={item.material_id}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>
                                                            <Form.Check
                                                                type="checkbox"
                                                                name="checkOption"
                                                                id={item.material_id}
                                                                className="check"
                                                                onChange={(e) => this.handleSelectChekBoxChange(e)}
                                                                value={item.material_id}
                                                                label={item.material_name}
                                                                disabled={item.isDisabled}
                                                                checked={item.checked}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center mt-3" style={{ gap: 12, flexWrap: "wrap" }}>
                                        {this.state.currentStep == 5 ? (
                                            <span style={{ color: "#059669", fontWeight: 600 }}><i className="fas fa-check-circle mr-1" />Material Allocation Submitted</span>
                                        ) : this.state.submitError ? (
                                            <span style={{ color: "#dc2626" }}>{this.state.submitError}</span>
                                        ) : null}
                                        <button style={FIN.btnPrimary} onClick={this.onSubmittedDetails}>
                                            {this.state.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-paper-plane" />}
                                            Allocate
                                        </button>
                                    </div>
                                </div>
                            ) : this.state.dataError != "" ? (
                                <div style={{ textAlign: "center", padding: "30px 0", color: "#64748b" }}>
                                    <div style={{ fontSize: 34, color: "#cbd5e1", marginBottom: 8 }}><i className="fal fa-box-open" /></div>
                                    <h6 style={{ color: "#64748b" }}>{this.state.dataError}</h6>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Container>

                <MaterialCreationModal
                    stateData={this.state}
                    show={this.state.materialCreationModal}
                    onHide={() => this.setState({ materialCreationModal: false })}
                    getMaterialTypes={this.props.getMaterialTypes}
                />
            </div>
        )
    }

}

export default withRouter(withApollo(compose(
    graphql(CREATE_MEATRIALS_ALLCATION, {
        name: "createMaterialAllocation"
    }),
)(MeatrialAssigning_to_Students))); 